export const apiUrlForThirdFieldOfFilter = {
  warehouse: "/api_supplier/warehouse",
  supplier: "/api_supplier/supplier/",
};
export const apiUrlForStatus = {
  purchase: "/api_po/v2/purchase_order_status/",
  transfer: "/api_order/transfer_order_status/",
  shipment: "/api_shipment/consignment_status/",
  allocation: {
    purchase: "/api_po/purchase_order_line_status/",
    transfer: "/api_order/transfer_order_line_status/",
  },
};

export const ALLOCATED_TO = [
  { id: "purchase_order", name: "Purchase Order" },
  { id: "receipt", name: "Receipt" },
  { id: "consignment", name: "Consignment" },
];

export { PURCHASE_ORDER_PAYMENT_STATUS_OPTIONS } from "../../../../purchaseOrder/constants/paymentStatusOptions";

export const BILL_STATUS_FOR_RULE = [
  { id: "draft", name: "Draft" },
  { id: "submit", name: "Submit" },
  { id: "approved", name: "Approved" },
  { id: "paid", name: "Paid" },
  { id: "voided", name: "Voided" },
];

export const idsForMultiSelectField = [
  3, 6, 7, 8, 10, 11, 12, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 25, 26, 27, 28, 29, 30, 31, 32,
  33, 34, 35, 36, 37, 38, 39, 40,
];

export const numericFieldIds = [
  6, 7, 8, 11, 12, 15, 16, 17, 18, 19, 20, 21, 22, 23, 28, 29, 30, 32, 31, 34, 38, 39,
];

export const idsForStatusField = [3, 10, 14, 27, 33];
export const idsForSupplierField = [7, 12, 28, 39];
export const idsForWarehousField = [6, 8, 11, 15, 16, 18, 20, 22, 28, 29, 30, 34, 40];
export const idsForProductField = [17, 19, 21, 26, 32];
export const idsForCurrencyField = [38];
